import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Cost Review',
    id: 'pE5lUn',
    description: 'costReviewModal.header',
  },
  continue: {
    defaultMessage: 'Continue',
    id: '0mEen7',
    description: 'costReviewModal.continue',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'qaq4Aq',
    description: 'costReviewModal.cancel',
  },
  close: {
    defaultMessage: 'Close',
    id: 'GnuPW/',
    description: 'costReviewModal.Close',
  },
  applySavings: {
    defaultMessage: 'Apply Savings',
    description: 'Text for button to apply selected savings recommendations',
    id: 'KjiDGE',
  },
});
